import actions from "./actions";

const initialState = {
  timesheets: [],
  total: 0,
  accountTotal: 0,
  teamSummaryCount: 0,
  requesting: false,
  saving: false,
  error: null,
};

export default function timesheetReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GET_LIST_TIMESHEET:
      return {
        ...state,
        requesting: true,
        error: null,
      };
    case actions.GET_LIST_TIMESHEET_SUCCESS:
      return {
        ...state,
        timesheets: action.timesheets,
        total: action.total,
        accountTotal: action.accountTotal,
        teamSummaryCount: action.teamSummaryCount,
        requesting: false,
        error: null,
      };
    case actions.GET_LIST_TIMESHEET_ERROR:
      return {
        ...state,
        requesting: false,
        error: action.error,
      };
    case actions.SAVE_TIMESHEET:
      return {
        ...state,
        saving: true,
        error: null,
      };
    case actions.SAVE_TIMESHEET_SUCCESS:
      return {
        ...state,
        saving: false,
        error: null,
      };
    case actions.SAVE_TIMESHEET_ERROR:
      return {
        ...state,
        saving: false,
        error: action.error,
      };
    default:
      return state;
  }
}
